import Apify from '@module/apify';

export const WallpaperAPI = Apify({
  load: {
    path: '/api/v4/studio-wallpapers/{advertId}',
    pathExt: true,
  },
});
